import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import { Row } from "antd";
import ViewFormularioHospedes from "../views/ViewFormularioHospedes";

const CadastroPropriedade: React.FC = () => (
  <>
    <ContatoZap />
    <ViewAppBar />
    <Row>
      <ViewFormularioHospedes />
    </Row>

    <ViewFooter />
  </>
);
export default CadastroPropriedade;
